module.exports = __webpack_public_path__ + "img/04.7e586863.webp";